import { render, staticRenderFns } from "./commonCom.vue?vue&type=template&id=27b1d7df&scoped=true&"
import script from "./commonCom.vue?vue&type=script&lang=js&"
export * from "./commonCom.vue?vue&type=script&lang=js&"
import style0 from "./commonCom.vue?vue&type=style&index=0&id=27b1d7df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1d7df",
  null
  
)

export default component.exports